export default {"src":"/_next/static/media/WhoWeAre_007A.b5846cbf.JPG","height":690,"width":1920};